<template>
  <v-card column class="ma-5 pa-2 font-weight-light">
        <!--added height -->
    <div class="local-table" md6 style="overflow: auto; height: 100%">
    <v-data-table
      v-if="incidents.length"
      class="text-caption elevation-1"
      :headers="headers"
      :items="incidents"
      style="height: 33vh"
      dense
      :items-per-page="5"
      :custom-sort="customSort"
    >
    
      <template v-slot:item.timestamp="{ item }">
        <a href="#" @click="showIncidentsOnMap(item)">{{ formatDate(item.timestamp, false) }}</a>
      </template>

      <template v-slot:item.incidents="{ item }">{{ item.incidents.length }}</template>

      <template v-slot:item.severity="{ item }">
        <v-chip :color="getColor(item)" small label dark class="mt-2 ml-1">{{ item.severity }}</v-chip>
      </template>
    </v-data-table>
    </div>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import store from '@/store/store'
import translate from '@/utils/genTable/multilanguageHelper.js'
import formatDate from '@/utils/formatDateHelper.js'
import dataTableSort from '@/utils/dataTableSort.js'

export default {
  name: 'IncidentReportResult',
  data() {
    return {
      headers: [
        { text: translate('Driver', 'incidentReport'), value: 'driver' },
        {
          text: translate('Vehicle Label', 'incidentReport'),
          value: 'vehicleLabel'
        },
        { text: translate('Date', 'incidentReport'), value: 'timestamp' },
        { text: translate('Severity', 'incidentReport'), value: 'severity' },
        {
          text: translate('Incident Count', 'incidentReport'),
          value: 'incidents'
        }
      ],
      loaded: false,
      sorts: {
        timestamp: 'date'
      }
    }
  },
  mounted() {
    dataTableSort.setSorts(this.sorts)
  },
  computed: {
    ...mapState('incidents', ['incidents']),
    formatDate() {
      return formatDate
    },
    customSort: () => dataTableSort.sort
  },
  methods: {
    showIncidentsOnMap(item) {
      //EventBus.$emit('DRAW_INCIDENT', item)
      store.dispatch('incidents/setSelectedIncident', item)
    },
    getColor(item) {
      if (item.severity == 2) {
        return 'red'
      }

      if (item.severity == 1) {
        return 'orange'
      }
      return 'yellow'
    }
  }
}
</script>


<style>
.v-application .mt-2 {
  margin-top: 0px !important;
}
.v-data-table .v-data-table__mobile-row {
  min-height: 14px !important;
}
</style>
<style >
/* Smanjuje razmak izmedju stavki u tabeli u mob. rezimu */
</style>
